export enum PIPELINE_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PAUSED = 'PAUSED',
  ERROR = 'ERROR',
  DRAFT = 'DRAFT',
}

export enum PIPELINE_STATUS_MAP_COLOR {
  ACTIVE = 'green',
  INACTIVE = 'blue',
  PAUSED = 'orange',
  DRAFT = 'gray',
  ERROR = 'red',
}

export enum PIPELINE_STATUS_MAP_TEXT {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  PAUSED = 'Paused',
  DRAFT = 'Draft',
  ERROR = 'Error',
}

export enum PIPELINE_RUNTIME_STATUS {
  STARTING = 'STARTING',
  RUNNING = 'RUNNING',
  FAILING = 'FAILING',
  TERMINATED = 'TERMINATED',
  RESTARTING = 'RESTARTING',
}
